var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoResult(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32.9004,
    r: 32,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 27.9004H31V31.9004H27V33.9004H31V37.9004H33V33.9004H37V31.9004H33V27.9004ZM32 22.9004C26.49 22.9004 22 27.3904 22 32.9004C22 38.4104 26.49 42.9004 32 42.9004H40C41.1 42.9004 42 42.0004 42 40.9004V32.9004C42 27.3904 37.51 22.9004 32 22.9004ZM32 40.9004C27.59 40.9004 24 37.3104 24 32.9004C24 28.4904 27.59 24.9004 32 24.9004C36.41 24.9004 40 28.4904 40 32.9004C40 37.3104 36.41 40.9004 32 40.9004Z",
    fill: "#989898"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResult);
export default __webpack_public_path__ + "static/media/noResult.a9c5cf92529a3c69c4ec4805e99916d5.svg";
export { ForwardRef as ReactComponent };